import React from "react";
import ExoploreNetworkBanner from "./ExploreNetworkBanner";
// Main component for Network 

export default function ExploreNetwork() {
  return (
    <>
    {/* Banner */}
      <ExoploreNetworkBanner />
    </>
  );
}
